import { APP_API_URL, APP_API_URL_V2 } from '../../utils/xhr-instance';
import axiosInstance, { axiosInstanceV2 } from '../axios';
export const CREATE_GROUP_API_URL = `${APP_API_URL}/product-group/create`;
export const CREATE_DRAFT_PRODUCT_API_URL = `${APP_API_URL_V2}/product/drafts/create`;
export const CREATE_BATCH_PRODUCT_API_URL = `${APP_API_URL_V2}/product/batches/create`;
export const UPDATE_DRAFT_PRODUCT_API_URL = `${APP_API_URL_V2}/product/drafts/update`;
export const DELETE_DRAFT_PRODUCT_API_URL = `${APP_API_URL_V2}/product/drafts`;
export const PUBLISH_DRAFT_PRODUCT_API_URL = `${APP_API_URL_V2}/product/drafts/publish`;
export const GET_DRAFT_PRODUCT_API_URL = `${APP_API_URL_V2}/product/drafts`;

export async function getPackagingList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/packaging-list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getProductList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/getAllProducts`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}
export async function getDefaultProductList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/inventory/master-products/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function masterProductClone(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/inventory/master-products/clone/${id}`,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export async function getProductMasterGroupList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/master-products-groups/list`,
			{
				params,
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw error;
	}
}
export async function cloneProductMasterGroup(body) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.post(
			`${APP_API_URL_V2}/inventory/master-products-groups/clone`,
			body,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data;
	} catch (error) {
		throw error;
	}
}

export async function getProducts(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(`${APP_API_URL_V2}/inventory/products/list`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export async function getProductDetails(id) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/products/details/${id}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data.product_details;
	} catch (error) {
		throw error;
	}
}

export async function getProductBatchList(params) {
	const token = localStorage.getItem('authToken');
	try {
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/product-batch`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export const getDraftProductList = async (id) => {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${GET_DRAFT_PRODUCT_API_URL}/${id}`, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
};

export const publishDraftProduct = async (id, data) => {
	try {
		let API_URL = `${PUBLISH_DRAFT_PRODUCT_API_URL}/${id}`;

		const token = localStorage.getItem('authToken');
		const res = await axiosInstanceV2.post(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
export const updateDraftProduct = async (id, data) => {
	try {
		let API_URL = `${UPDATE_DRAFT_PRODUCT_API_URL}/${id}`;

		const token = localStorage.getItem('authToken');
		const res = await axiosInstanceV2.put(API_URL, data, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		return error;
	}
};

export const createDraftProduct = async (body) => {
	try {
		let API_URL = CREATE_DRAFT_PRODUCT_API_URL;

		const token = localStorage.getItem('authToken');
		const res = await axiosInstanceV2.post(API_URL, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};

export const deleteDraftProduct = async (id) => {
	try {
		let API_URL = `${DELETE_DRAFT_PRODUCT_API_URL}/${id}`;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.delete(API_URL, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (err) {
		throw err;
	}
};

export const createBatchFromProductId = async (body) => {
	try {
		let API_URL = CREATE_BATCH_PRODUCT_API_URL;

		const token = localStorage.getItem('authToken');
		const res = await axiosInstanceV2.post(API_URL, body, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};

export const deleteBatch = async (body) => {
	try {
		let API_URL = `${APP_API_URL}/product/product-batch/delete`;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.delete(API_URL, {
			data: body,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (err) {
		throw err;
	}
};

export async function fetchProductDetails(id, params) {
	try {
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstance.get(`${APP_API_URL}/product/get-product-details/${id}`, {
			params,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data.data;
	} catch (error) {
		throw error;
	}
}

export const createProductGroup = async (formBody) => {
	try {
		let API_URL = CREATE_GROUP_API_URL;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.post(API_URL, formBody, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});
		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};

export const CREATE_CATOGERY_API_URL = `${APP_API_URL}/product-category/create`;

export const createProductCategory = async (formBody) => {
	try {
		let API_URL = CREATE_CATOGERY_API_URL;
		const token = localStorage.getItem('authToken');
		const res = await axiosInstance.post(API_URL, formBody, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
		});

		if (res?.data?.success) {
			return res?.data;
		} else {
			return res;
		}
	} catch (err) {
		throw err;
	}
};

export const exportProducts = async (params) => {
	try {
		const { type, mime_type, is_sample } = params;
		const token = localStorage.getItem('authToken');
		const { data } = await axiosInstanceV2.get(
			`${APP_API_URL_V2}/inventory/products/export/${type}/${mime_type}/${is_sample}`,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return data.data;
	} catch (error) {
		throw error;
	}
};
